module.exports = __webpack_public_path__ + "img/3Pey.6a687908.gif";